export class CartItem {
    constructor(element) {
        this.rowId = 'rowId' in element ? element.rowId : null;
        this.id = 'id' in element ? element.id : null;
        this.name = 'name' in element ? element.name : null;
        this.quantity = 'quantity' in element ? element.quantity : 1;
        this.options = 'options' in element ? element.options : [];
        this.price = 'price' in element ? element.price : null;
        this.priceTax = 'priceTax' in element ? element.priceTax : null;
        this.subtotal = 'subtotal' in element ? element.subtotal : null;
        this.total = 'total' in element ? element.total : null;
        this.tax = 'tax' in element ? element.tax : null;
        this.taxTotal = 'taxTotal' in element ? element.taxTotal : null;
        this.isPromo = 'isPromo' in element ? element.isPromo : false;
        this.promoPrice = 'promoPrice' in element ? element.promoPrice : null;
        this.promoPriceTax = 'promoPriceTax' in element ? element.promoPriceTax : null;
        this.promoSubtotal = 'promoSubtotal' in element ? element.promoSubtotal : null;
        this.promoTotal = 'promoTotal' in element ? element.promoTotal : null;
        this.promoTax = 'promoTax' in element ? element.promoTax : null;
        this.promoTaxTotal = 'promoTaxTotal' in element ? element.promoTaxTotal : null;
        this.associate = 'associate' in element ? element.associate : null;
        this.canChangeQuantity = 'canChangeQuantity' in element ? element.canChangeQuantity : true;
    }
};